const RankingCardBg = () => (
    <svg
        className='ranking-card-bg'
        width='318'
        height='303'
        viewBox='0 0 318 303'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            opacity='0.8'
            d='M304.211 274.848L197.982 213.036L0 96.8251L19.64 63.1128L217.622 179.324L323.849 241.133L304.211 274.848Z'
            fill='url(#paint0_linear_1544_2159)'
        />
        <path
            opacity='0.15'
            d='M223.28 262.759L157.504 224.512L34.916 152.605L47.0769 131.746L169.665 203.652L235.44 241.897L223.28 262.759Z'
            fill='url(#paint1_linear_1544_2159)'
        />
        <path
            d='M122.269 374.985L122.424 252.057L122.688 57.0925L161.976 57.1482L161.711 252.113L161.554 375.036L122.269 374.985Z'
            fill='url(#paint2_linear_1544_2159)'
        />
        <path
            d='M202.598 301.786L202.546 185.321L202.478 0.606207L241.502 0.613862L241.57 185.327L241.622 301.789L202.598 301.786Z'
            fill='url(#paint3_linear_1544_2159)'
        />
        <path
            d='M247.575 318.506L247.849 195.58L248.29 0.616951L269.84 0.523739L269.399 195.484L269.125 318.408L247.575 318.506Z'
            fill='url(#paint4_linear_1544_2159)'
            fillOpacity='0.15'
        />
        <path
            d='M186.751 160.974V205.658L161.975 191.27L122.686 168.447V51.3442H161.975V146.584L186.751 160.974Z'
            fill='url(#paint5_linear_1544_2159)'
            fillOpacity='0.8'
            style={{ mixBlendMode: 'screen' }}
        />
        <defs>
            <linearGradient
                id='paint0_linear_1544_2159'
                x1='28.5749'
                y1='89.7317'
                x2='290.164'
                y2='246.625'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='0.520833' stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0' />
            </linearGradient>
            <linearGradient
                id='paint1_linear_1544_2159'
                x1='52.6093'
                y1='148.216'
                x2='214.523'
                y2='245.395'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='0.520833' stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0' />
            </linearGradient>
            <linearGradient
                id='paint2_linear_1544_2159'
                x1='142.224'
                y1='60.7932'
                x2='142.206'
                y2='264.84'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='0.329196' stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0' />
            </linearGradient>
            <linearGradient
                id='paint3_linear_1544_2159'
                x1='226.164'
                y1='22.1834'
                x2='221.717'
                y2='281.949'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='0.520833' stopColor='#00FFFF' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0' />
            </linearGradient>
            <linearGradient
                id='paint4_linear_1544_2159'
                x1='261.314'
                y1='23.3298'
                x2='253.634'
                y2='297.391'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='0.520833' stopColor='#00FFFF' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0' />
            </linearGradient>
            <linearGradient
                id='paint5_linear_1544_2159'
                x1='154.718'
                y1='61.1142'
                x2='154.718'
                y2='251.708'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='1' stopColor='#00A6FF' />
            </linearGradient>
        </defs>
    </svg>
);

export default RankingCardBg;
